export class StartGameRequest {
    static Message = 'StartGameRequest';
}

export class StartGameResponse {
    static Message = 'StartGameResponse';
}
